import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/case-img.jpg";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>
                Performance-Driven Software Development: Accelerating Your
                Business Forward
              </h2>
            </div>
            <p>
              Being one of the prominent software development companies in
              Miami, we design software solutions that perform exceptionally
              well, taking into account factors like speed, scalability,
              flexibility, and, in addition, fulfilling business-unique
              purposes. Our powerful software solutions have helped firms in a
              variety of sectors achieve success by improving performance and
              opening up new growth prospects.
            </p>
            <p>
              By prioritizing collaboration and integrity, we ensure that our
              clients receive not just solutions but the solutions they need to
              thrive in today's competitive market.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
